import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "supplier-questions-sortable-list";

const keys = addTranslations(RESOURCE_NAME, {
    cancel: {
        en: "Cancel",
        fr: "Annuler",
    },
    save: {
        en: "Save",
        fr: "Enregistrer",
    },
    sort_questions_modal_title: {
        en: "Sort questions",
        fr: "Trier les questions",
    },
    no_group: {
        en: "Other questions",
        fr: "Autres questions",
    },
    no_name: {
        en: "Question not translated in the selected language",
        fr: "Question non traduite dans la langue sélectionnée",
    },
    group_not_translated: {
        en: "Name not translated in the selected language",
        fr: "Nom non traduit dans la langue sélectionnée",
    },
    toast_error_message: {
        en: "An error occurred while updating the questions order",
        fr: "Une erreur est survenue lors de la mise à jour de l'ordre des questions",
    },
});

export function useSupplierQuestionsSortableListTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
